import { Outlet } from "@remix-run/react";

export default function AuthenticationPage() {
  return (
    // <div className="overflow-hidden relative h-full flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-6 lg:px-0">
    <div className="h-screen flex items-center justify-center">
      <div className="w-full flex items-center justify-center h-full lg:col-span-3">
        <Outlet />
      </div>
      <div className="h-screen flex items-center justify-center lg:col-span-3 hidden lg:flex dark:border-l">
        <img
          src="/images/authentication.png"
          alt="Authentication"
          className="h-full w-auto max-w-none"
        />
      </div>
    </div>
  );
}
